<form (change)=(saveForm()) [formGroup]="huurInkomsten">
    <div formArrayName="huur">
        <div *ngFor="let item of huur.controls; let i = index; "
             [formGroupName]="i" class="row">
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Omschrijving inkomsten' : ''"
                                            class="custom-input-275 col-auto"
                                            formControlName="omschrijving"
                                            id="description"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="custom-input-150 col-auto"
                                              formControlName="bedrag"
                                              id="bedragPOU"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijHuur(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                 class="delete"
                                 icon="trash"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>

    <div *ngIf="huur.length === 0">
        <snelstart-ui-button (click)="addRijHuur()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Inkomsten tijdelijke verhuur eigen woning invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="huur.length > 0">
        <snelstart-ui-button (click)="addRijHuur()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Inkomsten tijdelijke verhuur eigen woning toevoegen
        </snelstart-ui-button>
    </div>

</form>

<div *ngIf="huur.length > 0">
    <form [formGroup]="huurInkomsten">
        <div *ngIf="kosten.length > 0" class="pt-2">
            <div formArrayName="kosten">
                <div *ngFor="let kosten of kosten.controls; let i = index; "
                     [formGroupName]="i" class="row">

                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="omschrijving"
                                                    id="omschrijvingKosten"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150 col-auto"
                                                      formControlName="bedrag"
                                                      id="bedragKosten"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijKosten(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         class="delete"
                                         icon="trash"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>

                </div>
            </div>
        </div>

        <div *ngIf="kosten.length === 0">
            <snelstart-ui-button (click)="addRijKostenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Kosten tijdelijke verhuur eigen woning invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="kosten.length > 0">
            <snelstart-ui-button (click)="addRijKostenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Kosten tijdelijke verhuur eigen woning toevoegen
            </snelstart-ui-button>
        </div>
    </form>

</div>
